// Add your JS customizations here
jQuery(document).ready(function($) {

	let wowNew = new WOW(
		{
			boxClass:     'wow',      // default
			animateClass: 'animated', // default
			offset:       0,          // default
			mobile:       false,       // default
			live:         true        // default
		}
	)
	wowNew.init();

	// Navbar Functions

	$('.navbar-main #main-menu > li:first-child a').attr('href', 'javascript:void(0)');
	$('.navbar-active #main-menu-main-active > li:first-child a').attr('href', 'javascript:void(0)');

	if ($(document).scrollTop() >= 30) {
		$(".navbar-active").removeClass("active");
		$(".navbar-active").removeClass("closed");

		$(".navbar-active").addClass("show");

		$("#main-nav.navbar-main").css('visibility', 'hidden');

		$("#main-nav.navbar-active > .dropdown").css("display", "none");

		$('.navbar-mobile').addClass('scroll');

	} else {

		$('.navbar-mobile').removeClass('scroll');

		$(".navbar-active").removeClass("show");
		$(".navbar-main").css('visibility', 'visible');

		$( ".navbar-main li:first-child a" ).on( "click", function(event) {

			$(".navbar-active").addClass("active");
			$(".navbar-active").removeClass("closed");

			setTimeout(() => {
				$(".navbar-main").css('visibility', 'hidden');
			}, 400);

			$(".navbar-main li:first-child ul").removeClass("show");
			$(".navbar-main li:first-child a").removeClass("show");

			$(".navbar-active li:first-child a").addClass("show");
			$(".navbar-active li:first-child ul").addClass("show");

			$(".navbar-active > .dropdown").css("display", "flex");

		} );

		$( ".navbar li:first-child a" ).on( "click", function(event) {

			$(".navbar-active").addClass("active");
			$(".navbar-active").removeClass("closed");

			setTimeout(() => {
				$(".navbar-main").css('visibility', 'hidden');
			}, 400);

			$(".navbar-main li:first-child ul").removeClass("show");
			$(".navbar-main li:first-child a").removeClass("show");

			$(".navbar-active li:first-child a").addClass("show");
			$(".navbar-active li:first-child ul").addClass("show");

			$(".navbar-active > .dropdown").css("display", "flex");

		} );

		if ($(document).scrollTop() <= 30) {
			$(".navbar-active .dropdown img").on("click", function(event) {
				$("#main-nav.navbar-active > .dropdown").css("display", "none");

				$(".navbar-active li:first-child a").removeClass("show");
				$(".navbar-active li:first-child ul").removeClass("show");

				$(".navbar-active").addClass("closed");
				$(".navbar-active").removeClass("active");

				$(".navbar-main").css('visibility', 'visible');
			});
		}

	}

	$(document).on( 'scroll', function(){
		if ($(document).scrollTop() >= 30) {
			$(".navbar-active").removeClass("active");
			$(".navbar-active").removeClass("closed");

			$(".navbar-active").addClass("show");

			$(".navbar-active > .dropdown").css("display", "none");

			$(".navbar-main").css('visibility', 'hidden');

			$( ".navbar-active li:first-child a" ).on( "click", function(event) {

				$(".navbar-main li:first-child ul").removeClass("show");
				$(".navbar-main li:first-child a").removeClass("show");

				$(".navbar-active li:first-child a").addClass("show");
				$(".navbar-active li:first-child ul").addClass("show");

				$(".navbar-active > .dropdown").css("display", "flex");

			} );

			if ($(document).scrollTop() >= 30) {
				$(".navbar-active .dropdown img").on("click", function(event) {
					$(".navbar-active > .dropdown").css("display", "none");
					// $(".navbar-active li:first-child a").removeClass("show");
					// $(".navbar-active li:first-child ul").removeClass("show");
				});
			}

		} else {
			$(".navbar-active").removeClass("show");
			$(".navbar-main").css('visibility', 'visible');

			$( ".navbar-main li:first-child a" ).on( "click", function(event) {

				$(".navbar-active").addClass("active");
				$(".navbar-active").removeClass("closed");

				setTimeout(() => {
					$(".navbar-main").css('visibility', 'hidden');
				}, 400);

				$(".navbar-main li:first-child ul").removeClass("show");
				$(".navbar-main li:first-child a").removeClass("show");

				$(".navbar-active li:first-child a").addClass("show");
				$(".navbar-active li:first-child ul").addClass("show");

				$(".navbar-active > .dropdown").css("display", "flex");

			} );

			$(".navbar-active .dropdown img").on("click", function(event) {

				$("#main-nav.navbar-active > .dropdown").css("display", "none");

				if ($(document).scrollTop() <= 30) {
					// $(".navbar-active li:first-child a").removeClass("show");
					// $(".navbar-active li:first-child ul").removeClass("show");

					$(".navbar-active").addClass("closed");
					$(".navbar-active").removeClass("active");

					$(".navbar-main").css('visibility', 'visible');
				}
			});
		}
	});

	$('.hamburger-menu-closed').on('click', function (event) {

		$('.navbar-mobile').addClass('active');
		$('.navbar-mobile-active').addClass('active');
		$('.navbar-mobile-active').removeClass('closed');

		setTimeout(() => {
			$('.navbar-mobile-active  .mobile-logo').css('position', 'fixed');
			$('.navbar-mobile-active .mobile-logo').css('display', 'block');
		}, 800);

	});

	$('.hamburger-menu-open').on('click', function (event) {

		$('.navbar-mobile').removeClass('active');
		$('.navbar-mobile-active').removeClass('active');
		$('.navbar-mobile-active').addClass('closed');

		setTimeout(() => {
			$('.navbar-mobile-active .mobile-logo').css('position', 'absolute');
			$('.navbar-mobile-active .mobile-logo').css('display', 'none');

		}, 100);
	})

	$('.navbar-mobile-active .navbar-nav a.dropdown-toggle').html('Services <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 480L256 32 512 480H0z"/></svg>')

	$(document).on( 'scroll', function(){

		if ($(document).scrollTop() >= 30) {

			$('.navbar-mobile').addClass('scroll');

		} else {

			$('.navbar-mobile').removeClass('scroll');

		}

	});

	// End Navbar Functions

	// Quick Contact Form

	$(".quick-contact-button").on("click", function(e) {
		e.preventDefault();

		$(".quick-contact-form").addClass('active');
		$(".quick-contact-form").removeClass('closed');

		setTimeout(() => {
			$(".quick-contact-form img:not(.quick-contact-close)").css('display', 'block');

		}, 800);
	});

	$(".quick-contact-close").on("click", function() {
		$(".quick-contact-form").removeClass('active');
		$(".quick-contact-form").addClass('closed');

		setTimeout(() => {
			$(".quick-contact-form img:not(.quick-contact-close)").css('display', 'none');

		}, 100);
	});

	// End Quick Contact Form

	// Reviews

	$(".ti-widget .ti-next").html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')
	$(".ti-widget .ti-prev").html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')

	// End reviews

	// Services

	$('.home-services .load-more').on('click', (e) => {
		e.preventDefault();

		$('.home-services .services-overlay').addClass('active');

		$('.home-services .load-more').addClass('active');
		$('.home-services .see-less').addClass('active');

		$('.home-services .services .item').addClass('active');
	});

	$('.home-services .see-less').on('click', (e) => {
		e.preventDefault();

		$('.home-services .services-overlay').removeClass('active');

		$('.home-services .load-more').removeClass('active');
		$('.home-services .see-less').removeClass('active');

		$('.home-services .services .item').removeClass('active');
	});

	// End Services

	// News

	$(".widget-area aside.widget_categories select").select2();
	$(".widget-area aside.widget_archive select").select2();

	$(".select2 #select2-archives-dropdown-2-container").attr('title', 'Archives').html('Archives')


	$(".pagination a.prev").html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>');
	$(".pagination a.next").html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>');

	// End News

	// Posts

	$('.back-top').on('click', (e) => {
		e.preventDefault();

		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

	// End Posts

	// About

	$('.about-accreditations .accreditations').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					arrows: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.testimonials-block .testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	$('.hero-lettings-details .lettings-carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	$('.about-accreditations .accreditations .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')
	$('.about-accreditations .accreditations .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')

	$('.testimonials-block .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')
	$('.testimonials-block .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')

	$('.hero-lettings-details .lettings-carousel .slick-prev').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')
	$('.hero-lettings-details .lettings-carousel .slick-next').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M384 256L0 32V480L384 256z"/></svg>')

	function changeImageOnMobile(container) {
		let imgForMobile = $(`${container}`).data('mobile');
		let imgForDesktop = $(`${container}`).data('desktop');


		if ($(window).width() < 768) {
			$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
		}
		else {
			$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
		}

		$(window).on('resize', function() {
			if ($(window).width() < 768) {
				$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
			}
			else {
				$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
			}
		});
	}

	changeImageOnMobile('.breaker.home')
	changeImageOnMobile('.breaker.about');
	changeImageOnMobile('.about-quote');

	// End About

	// Services

	$('.accordion .accordion-item').click(function() {
		let accordionItem = $(this).find('.accordion-collapse');
		let title = $(this).find('.question-title');

		if(title.hasClass('active')) {
			title.removeClass('active');
		} else {
			title.addClass('active');
		}
	});

});
